import { AppPage, BusinessInsightComponent as BIC, MimaText, Searchbar,  } from "../../components";
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { useNavigate } from "react-router-dom";



const OrderPage = () => {
    const navigate = useNavigate();

    return (
        <AppPage pageTitle='Inventory'>
        <div className={styles.main__metrics}>
            <BIC
                title={'Stock Count'}
                amount={'150'}
                styleClass={styles.main__metrics_active}
            />
            <BIC
                title={'Stock Value'}
                amount={'NGN 150,000'}
                styleClass={styles.main__metrics_active}
            />
            <BIC
                title={'Order'}
                amount={'42'}
                styleClass={styles.main__metrics_active}
                onClick={ () => 
                    navigate('/orderPage')
                }
            />
            <BIC
                title={'Items Low On Stock'}
                amount={'50'}
                styleClass={styles.main__metrics_error}
                onClick={ () => 
                    navigate('/itemsStock')
                }
            />
        </div>

        <div className={styles.searchbtnsection}>


            <div className='searchInMiddle'>
                <MimaText                
                variant='h3'
                mr='30'
                color='#1F68D6'

                >Orders</MimaText>
                <Searchbar
                    placeholder="Search..."
                    variant="wide"                                                               
                />
            </div>           
        </div>

        <div className={styles.simpleTable}>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th> DATE </th>
                                        <th> ORDER NUMBER </th>
                                        <th> PRODUCT NAME </th>
                                        <th> VARIATION </th>
                                        <th> QUANTITY</th>
                                        <th> PRICE</th>
                                        <th> STATUS</th>											
                                    </tr>
                                </thead>
                                <tbody>										
                                        <tr>
                                            <td> 01/11/2022 </td>
                                            <td> 01 </td>
                                            <td> GUCCI </td>
                                            <td> BLACK </td>
                                            <td> 2 </td>
                                            <td> NGN 30,000 </td>
                                            <td className={styles.paid}> Success </td>                                            											   
                                        </tr>									
                                        <tr>
                                            <td> 02/12/2022 </td>
                                            <td> 002 </td>
                                            <td> VINTAGE </td>
                                            <td> BLUE </td>
                                            <td> 5 </td>
                                            <td> NGN 25,000 </td>
                                            <td className={styles.paid}> Success </td>                                          										   
                                        </tr>									
                                        <tr>
                                            <td> 03/12/2022 </td>
                                            <td> 003 </td>
                                            <td> REFRIDGERATOR </td>
                                            <td> BLACK </td>
                                            <td> 50 </td>
                                            <td> NGN 50,000 </td>
                                            <td className={styles.paid}> Success </td>                                        										   
                                        </tr>									
                                </tbody>
                            </table>
                        </div>
    </AppPage>
    )
}

export default OrderPage;